import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Outlet } from 'react-router-dom'
import { useQueryContactAddress } from '../../../hooks/fetch/contactAddress/useQueryContactAddress'
import { useQueryContactGroup } from '../../../hooks/fetch/contactGroup/useQueryContactGroup'
import useCurrentPath from '../../../hooks/useCurrentPath'
import {
  categoryFilter,
  resetAllContactAddress,
  resetContactAddress,
  selectAllContacts,
  selectContactFilterType,
  sortContact,
  setFetched,
  selectIsFetched,
} from '../../../slices/contactAddressSlice'
import { resetGroup } from '../../../slices/groupSlice'
import { contactGroupSerializer } from '../../../util/contactGroupSerializer'
import NowLoading from '../../UtilComponent/level_1/NowLoading'
import ContactBoxHeader from './ContactBoxHeader/ContactBoxHeader'
import { contactHeaders } from './ContactBoxHeader/contactHeaders'
import { selectRole } from '../../../slices/authSlice'
import { Category } from '../../../common/ContactAddress.type'

const ContactBox = () => {
  const dispatch = useDispatch()
  const { currentPath } = useCurrentPath()

  const { data: contactGroups } = useQueryContactGroup()

  const allContactAddresses = useSelector(selectAllContacts)
  const loggedinUserRole = useSelector(selectRole)
  const contactFilterType = useSelector(selectContactFilterType)
  const isFetched = useSelector(selectIsFetched)

  useEffect(() => {
    if (contactGroups && allContactAddresses.length) {
      const initialContactGroups = contactGroups.map((contactGroup) => {
        return contactGroupSerializer(contactGroup, allContactAddresses)
      })
      dispatch(resetGroup(initialContactGroups))
    }
  }, [allContactAddresses, contactGroups, dispatch])

  // const { data: contactAddresses, isLoading, error } = useQueryContactAddress()
  const { data: contactAddresses, isLoading, isError, error } = useQueryContactAddress()

  useEffect(() => {
    if (!isError && contactAddresses && !isFetched) {
      dispatch(resetAllContactAddress(contactAddresses))
      dispatch(resetContactAddress(contactAddresses))
      dispatch(categoryFilter((contactFilterType === "" ? (loggedinUserRole !== 4 ? 'all' : 'personal') : contactFilterType as Category)))
      dispatch(sortContact({ sortOption: 'lastNameKana', orderAsc: true }))
      dispatch(setFetched())
    }
  }, [contactAddresses, isError, dispatch, contactFilterType, loggedinUserRole, isFetched])

  if (isLoading) return <NowLoading />

  if (error) console.error(error)

  let targetPath = ''
  if (currentPath.match(/contactAddress/)) targetPath = 'contactAddress'
  else if (currentPath.match(/contactGroup/)) targetPath = 'contactGroup'
  else targetPath = 'contactAddress'

  return (
    <div className="box w-contacts-box">
      <ContactBoxHeader target={targetPath as keyof typeof contactHeaders} />
      <Outlet />
    </div>
  )
}

export default ContactBox
